/**
 * Checks if the browser is currently online.
 * @returns {boolean} Returns true if the browser is online, otherwise returns false.
 */
export const isOnline = () =>
  typeof navigator !== "undefined" && typeof navigator.onLine === "boolean" ? navigator.onLine : true;
